import { createReducer, on } from '@ngrx/store';
import * as moment from 'moment';
import * as appChatActions from '../actions/app-chat.action';
//
// Reducer Interface
//
export interface IAppChatState {
  currentConnectionId : string;
  //
  // current deal id. messages related to this dealid will be loaded
  //
  currentDealId : string;
  //
  // sales consultant sending the message
  //
  currentSalesConsultant: string,
  //
  // opens or closes the panel
  //
  showPanel : boolean;
  //
  // list of all chats
  //
  messages : {  
    commentGivenBy:string, 
    commentDate:string, 
    commentTXT: string,
    userRole:string}[];
}
//
// Initial State
//
export const APP_CHAT_INITIAL_STATE: IAppChatState = {
  currentConnectionId: null,
  currentDealId : null,
  currentSalesConsultant: null,
  showPanel: false,
  messages : [],
};
export const reducer = createReducer(
  APP_CHAT_INITIAL_STATE,
  on(appChatActions.AppChatShowPanel, (state, action) => _showPanel(state, action)),
  on(appChatActions.AppChatHidePanel, state => _hidePanel(state)),
  on(appChatActions.AppChatInitialFetchSucceed, (state, action) => _setChats(state, action)),
  on(appChatActions.AppChatSendMessageSucceed, (state, action) => _setChat(state, action)),
  on(appChatActions.AppChatAddMessage, (state, action) => _addChat(state, action)),
);
//
// _showPanel()
//
function _showPanel(state: IAppChatState, action): IAppChatState {
   return {...state, showPanel: true, currentConnectionId: action.payload.currentConnectionId,
    currentDealId: action.payload.dealTransactionId,
    currentSalesConsultant: action.payload.salesConsultant,
    messages:[]
  };    
}
//
// _hidePanel()
//
function _hidePanel(state: IAppChatState): IAppChatState {
  return {...state, showPanel: false, currentConnectionId:null,currentDealId:null,currentSalesConsultant:null, messages:[]};    
}

function _setChats(state: IAppChatState, action): IAppChatState{
  let messages = [];
  if(Array.isArray(action.payload) && action.payload.length>0){
    messages = action.payload.sort((a,b)=> new Date(a.commentDate).getTime() - new Date(b.commentDate).getTime()); 
  }
  // else if (action.payload && action.payload.dealDetail && action.payload.dealDetail.dealData && Array.isArray(action.payload.dealDetail.dealData.dealTermComments)) { 
  //   messages = action.payload.dealDetail.dealData.dealTermComments;
  // }
  return {...state, messages: messages};
}

function _setChat(state: IAppChatState, action): IAppChatState{
  const dateTime = new Date();
  const dateTimeString = moment(dateTime.toISOString()).format("MM/DD/YYYY HH:mm:ss");
  const messsage = {
    commentGivenBy:state.currentSalesConsultant, 
    commentDate:dateTimeString, 
    commentTXT: action.payload,
    userRole : "SALES_MANAGER"
  };
  const _messages = [...state.messages];
  _messages.push(messsage);
  return {...state, messages: _messages};
}

function _addChat(state: IAppChatState, action): IAppChatState{
  const dateTime = new Date(action.payload.commentDate);
  const dateTimeString = moment(dateTime.toISOString()).format("MM/DD/YYYY HH:mm:ss");
  const messsage = {
    commentGivenBy:action.payload.commentGivenBy,
    commentDate:dateTimeString, 
    commentTXT: action.payload.commentTXT,
    userRole : action.payload.userRole
  };
  const _messages = [...state.messages];
  _messages.push(messsage);
  return {...state, messages: _messages};
}
